import React from "react";
import { useParams, Link } from "react-router-dom";
import "../styles/JobDetails.css";

const jobData = [
  { 
    id: 1, 
    title: "Software Engineer", 
    company: "Google", 
    location: "Remote", 
    salary: "₹15 LPA", 
    logo: "../google.png", 
    posted: "2024-02-20", 
    description: "Join Google's software engineering team and work on cutting-edge technologies.",
    requirements: [
      "Experience with JavaScript, React, or Python.",
      "Strong problem-solving skills.",
      "Knowledge of cloud computing is a plus."
    ],
    applyLink: "https://careers.google.com"
  },
  { 
    id: 2, 
    title: "Data Scientist", 
    company: "Amazon", 
    location: "Bangalore", 
    salary: "₹20 LPA", 
    logo: "../amazon.png", 
    posted: "2024-02-18", 
    description: "Analyze large datasets and improve customer experience using AI and ML.",
    requirements: [
      "Proficiency in Python, SQL, and ML algorithms.",
      "Experience in data visualization.",
      "Familiarity with AWS is a plus."
    ],
    applyLink: "https://amazon.jobs"
  },
  { 
    id: 3, 
    title: "Frontend Developer", 
    company: "Microsoft", 
    location: "Hyderabad", 
    salary: "₹12 LPA", 
    logo: "../microsoft.png", 
    posted: "2024-02-19", 
    description: "Build amazing front-end experiences with modern web technologies.",
    requirements: [
      "Strong skills in React.js, HTML, CSS, and JavaScript.",
      "Experience with UI/UX principles.",
      "Familiarity with TypeScript is a plus."
    ],
    applyLink: "https://careers.microsoft.com"
  }
];

const JobDetails = () => {
  const { id } = useParams();
  const job = jobData.find((job) => job.id === parseInt(id));

  if (!job) {
    return <h2 className="not-found">Job Not Found</h2>;
  }

  return (
    <div className="job-details">
      <div className="job-header">
        <img src={job.logo} alt={job.company} className="company-logo" />
        <div>
          <h1>{job.title}</h1>
          <h3>{job.company}</h3>
          <p>{job.location} • {job.salary}</p>
        </div>
      </div>

      <section className="job-description">
        <h2>Job Description</h2>
        <p>{job.description}</p>
      </section>

      <section className="job-requirements">
        <h2>Requirements</h2>
        <ul>
          {job.requirements.map((req, index) => (
            <li key={index}>{req}</li>
          ))}
        </ul>
      </section>

      <div className="job-actions">
        <a href={job.applyLink} target="_blank" rel="noopener noreferrer" className="apply-btn">
          Apply Now
        </a>
        <Link to="/jobs" className="back-btn">Back to Jobs</Link>
      </div>
    </div>
  );
};

export default JobDetails;
